import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["about", "open", "close"]

  connect() {
    this.openDisplay = this.hasOpenTarget ? getComputedStyle(this.openTarget).display : "inline-block"
    const closeDisplay = this.hasCloseTarget ? getComputedStyle(this.closeTarget).display : "inline-block"
    this.closeDisplay = closeDisplay === "none" ? "inline-block" : closeDisplay
  }

  open() {
    if (this.hasAboutTarget) this.aboutTarget.classList.remove("tw-hidden")
    if (this.hasOpenTarget) {
      this.openTarget.style.display = "none"
      this.openTarget.setAttribute("aria-expanded", "true")
    }
    if (this.hasCloseTarget) {
      this.closeTarget.style.display = this.closeDisplay
      this.closeTarget.setAttribute("aria-expanded", "true")
    }
  }

  close() {
    if (this.hasAboutTarget) this.aboutTarget.classList.add("tw-hidden")
    if (this.hasOpenTarget) {
      this.openTarget.style.display = this.openDisplay
      this.openTarget.setAttribute("aria-expanded", "false")
    }
    if (this.hasCloseTarget) {
      this.closeTarget.style.display = "none"
      this.closeTarget.setAttribute("aria-expanded", "false")
    }
  }
}
